import { Stack } from '@mui/material';

import { CheckIcon } from '@/components/icons/CheckIcon';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { MenuItemSecondaryTypography } from '@/components/typography/MenuItemSecondaryTypography';
import { MenuItemTypography } from '@/components/typography/MenuItemTypography';
import { COLORS } from '@/styles/tokens/colors';

export interface BackendTypeaheadOptionProps
  extends React.HTMLAttributes<HTMLLIElement> {
  isSelected: boolean;
  display: React.ReactNode;
  badgeText?: React.ReactNode;
  /**
   * Optional secondary text displayed below the main display text
   * with smaller text-secondary styling
   */
  secondaryText?: string;
}

export function BackendTypeaheadOption({
  isSelected,
  display,
  badgeText,
  secondaryText,
  ...props
}: BackendTypeaheadOptionProps) {
  return (
    <Stack
      sx={{
        ':hover': {
          backgroundColor: `${COLORS.FUNCTIONAL.HOVER} !important`,
        },
      }}
      alignItems="center"
      width="100%"
      direction="row"
      justifyContent="space-between"
      component="li"
      spacing={0.5}
      {...props}
    >
      <Stack direction="column" spacing={0} flex={1}>
        <MenuItemTypography>{display}</MenuItemTypography>
        {secondaryText && (
          <MenuItemSecondaryTypography>
            {secondaryText}
          </MenuItemSecondaryTypography>
        )}
      </Stack>
      {badgeText && (
        <Badge variant={BadgeVariants.SecondaryFilled} display={badgeText} />
      )}
      {isSelected && (
        <CheckIcon color={COLORS.FUNCTIONAL.SUCCESS[500]} size={18} />
      )}
    </Stack>
  );
}
